import React from 'react';
import { LISTS_INDENTATION_MENU_SECTION, LISTS_INDENTATION_MENU_SECTION_RANK, TASK_LIST_MENU_ITEM } from '@atlaskit/editor-common/toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { TaskListMenuItem } from './TaskListMenuItem/TaskListMenuItem';
export var getTasksAndDecisionsToolbarComponents = function getTasksAndDecisionsToolbarComponents(_ref) {
  var api = _ref.api;
  if (!expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) {
    return [];
  }
  return [{
    type: TASK_LIST_MENU_ITEM.type,
    key: TASK_LIST_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[TASK_LIST_MENU_ITEM.key]
    }],
    component: function component(_ref2) {
      var parents = _ref2.parents;
      return /*#__PURE__*/React.createElement(TaskListMenuItem, {
        api: api,
        parents: parents
      });
    }
  }];
};